import {Navigate, type NavigateProps} from 'react-router-dom';
import {mergeTrackingParams} from '../utils/tracking-params';

/**
 * Wrapper around <Navigate> that carries stored tracking params
 * (utm_*, gclid, etc.) into the destination URL.
 * Only merges params when `to` is a string; To objects pass through unchanged.
 */
export const NavigateWithTracking = ({to, ...rest}: NavigateProps) => {
  const destination = typeof to === 'string' ? mergeTrackingParams(to) : to;
  return <Navigate to={destination} {...rest} />;
};
